"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.migratePaletteSpec = migratePaletteSpec;
exports.traverseBlocks = traverseBlocks;
function migratePaletteSpec(spec) {
  let version = spec.schemaVersion || 1;
  let latest = version;
  for (let it of migrations) {
    if (version < it.version) {
      it.migrate(spec);
      latest = it.version;
    }
  }
  spec.schemaVersion = latest;
}
const migrations = [{
  version: 2,
  migrate(spec) {
    let root = traverseBlocks({
      block: spec.root
    }, block => {
      var _block$block$classes, _block$block$children, _block$block$children2, _block$block$children3;
      if (block.block.type === "layout" && (_block$block$classes = block.block.classes) !== null && _block$block$classes !== void 0 && _block$block$classes.includes("dumbapp-button-layout") && ((_block$block$children = block.block.children) === null || _block$block$children === void 0 ? void 0 : (_block$block$children2 = _block$block$children[0]) === null || _block$block$children2 === void 0 ? void 0 : (_block$block$children3 = _block$block$children2.block) === null || _block$block$children3 === void 0 ? void 0 : _block$block$children3.type) === "dumbapp") {
        return {
          replace: block.block.children[0],
          children: []
        };
      }
      return {
        children: block.block.children
      };
    });
    spec.root = root.block;
  }
}];
function traverseBlocks(block, func) {
  let layer = [{
    block
  }];
  let root = block;
  while (layer.length > 0) {
    let nextLayer = [];
    for (let it of layer) {
      let res = func(it.block);
      if (res.replace) {
        if (it.parent) {
          it.parent.children.splice(it.index, 1, res.replace);
        } else {
          root = res.replace;
        }
      }
      if (res.children) {
        it.block.block.children = res.children;
        nextLayer = nextLayer.concat(res.children.map((child, index) => {
          return {
            block: child,
            parent: it.block.block,
            index
          };
        }));
      }
    }
    layer = nextLayer;
  }
  return root;
}
//# sourceMappingURL=migrate.js.map